<template>
  <div class="service-records-empty-state">
    <div class="service-records-empty-state__icon">
      <i class="pi pi-file-edit" />
    </div>
    <div class="service-records-empty-state__content">
      <div class="service-records-empty-state__title">
        {{ title }}
      </div>
      <div class="service-records-empty-state__subtitle">
        {{ subtitle }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string;
  subtitle?: string;
}

withDefaults(defineProps<Props>(), {
  title: "Ingen servicerapport ennå",
  subtitle:
    "Det er ingen servicerapporter registrert for denne tjenesten ennå. Servicerapporter vil vises her når de blir opprettet.",
});
</script>

<style lang="scss" scoped>
.service-records-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  background-color: rgba($color-primary-lighter, 0.3);
  border-radius: 8px;
  border: 2px solid rgba($color-primary, 0.2);
  text-align: center;
  gap: 1rem;

  @media (max-width: $bp-sm) {
    padding: 2rem 1rem;
  }

  &__icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background-color: rgba($color-primary, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: $bp-sm) {
      width: 48px;
      height: 48px;
    }

    i {
      font-size: 2rem;
      color: $color-primary;

      @media (max-width: $bp-sm) {
        font-size: 1.5rem;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 400px;
  }

  &__title {
    font-size: $font-size-xl;
    font-weight: 600;
    color: $color-primary-darker;

    @media (max-width: $bp-sm) {
      font-size: $font-size-lg;
    }
  }

  &__subtitle {
    font-size: $font-size-base;
    color: $color-text-secondary;
    line-height: 1.5;

    @media (max-width: $bp-sm) {
      font-size: $font-size-sm;
    }
  }
}
</style>
